'use strict';

import { ajaxWrapNew, ResponseDispatcher } from './ajaxWrapNew.js';

function handleTiktokLogin() {
    ajaxWrapNew({
        method: 'POST',
        data: {
            ajax: 1,
            action: 'tiktokLogin'
        },
        success: function (data) {
            ResponseDispatcher.handle(data, 'tiktokLogin');
        },
        dataType: 'json'
    });
}

/* function handleTwitterLogin() {
    ajaxWrapNew({
        method: 'POST',
        data: {
            ajax: 1,
            action: 'twitterLogin'
        },
        success: function (data) {
            ResponseDispatcher.handle(data, 'twitterLogin');
        },
        dataType: 'json'
    });
} */

export function loadAuth() {

}

// @ts-ignore
window.handleTiktokLogin = handleTiktokLogin;